import { types } from 'mobx-state-tree'

import { AppConfig } from '.'

export const AppConfigRoot = types.model('AppConfigRoot', {
  appConfig: types.optional(AppConfig, {}),
})
